/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M16.5.75v22.5c0-.0005 0 .0005 0 0-.0008.4135-.3363.75-.75.75a.7502.7502 0 0 1-.7379-.6152L15 23.25V.75c0 .0005 0-.0005 0 0 .0008-.4135.3363-.75.75-.75a.7502.7502 0 0 1 .7379.6152L16.5.75Zm7.5 6v16.5c0 .0005 0-.0005 0 0-.0008.4135-.3363.75-.75.75a.7502.7502 0 0 1-.7379-.6152L22.5 23.25V6.75c0-.0005 0 .0005 0 0 .0008-.4135.3363-.75.75-.75a.7502.7502 0 0 1 .7379.6152L24 6.75ZM1.5 17.25v6c0-.0005 0 .0005 0 0-.0008.4135-.3363.75-.75.75a.7502.7502 0 0 1-.738-.6152L0 23.25v-6c0 .0005 0-.0005 0 0 .0008-.4135.3363-.75.75-.75a.7502.7502 0 0 1 .738.6152l.012.1348Zm7.5-6v12c0 .0005 0-.0005 0 0-.0008.4135-.3363.75-.75.75a.7502.7502 0 0 1-.738-.6152L7.5 23.25v-12c0-.0005 0 .0005 0 0 .0008-.4135.3363-.75.75-.75a.7502.7502 0 0 1 .738.6152L9 11.25Z"
    clipRule="evenodd"
  />,
  'Flame'
);
